import { Reducer } from 'react';

import { MediaApiActions } from '../actions';
import { MediaElementActionPayload, MediaElementApi } from '../types';

export const MediaApiReducer: Reducer<MediaElementApi | undefined, MediaElementActionPayload> = (
  state: MediaElementApi | undefined,
  action: MediaElementActionPayload,
): MediaElementApi => {
  const { payload } = action;
  if (action.type === MediaApiActions.UPDATE_MEDIA_API_STATE) {
    return { ...state, ...(payload as MediaElementApi) };
  }
  return { ...state };
};
